import authApi from "../apis/authApi";
import { USER_LOGIN, USER_LOGOUT } from "./constants";

export const loginUser = (payload) => {
  return async (dispatch) => {
    try {
      const response = await authApi.login(payload);
      // console.log(response.data);
      const { data } = response.data;
      await dispatch({
        type: USER_LOGIN,
        payload: { ...data.user, token: data.jwtToken },
      });
      return Promise.resolve(response);
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch({ type: USER_LOGOUT });
  };
};
